/**
 * Correct-answer feedback card.
 */
import { Icon } from "@iconify/react";
import { Box } from "@mui/material";
import React from "react";
import { useTranslation } from 'react-i18next';

import { VText } from "form";

/**
 * Shows the correct choice after a successful attempt.
 *
 * @param {{ text?: string }} props
 */
const CorrectAnswerCard = (props) => {

  const { t } = useTranslation('common');

  const { children } = props;

  return <>
    <Box className="flex mt-10 border border-solid border-green-500 p-8 rounded-lg border-l-8">
      <VText className="flex items-center text-xl text-green-500 font-bold">
        <Icon icon="fa:thumbs-o-up" />&nbsp;{t("Correct")}
      </VText>
      <Box className="flex-fill">
        {children && <VText className="mt-3" color="secondary">{children}</VText>}
      </Box>
    </Box>
  </>;
};

export default CorrectAnswerCard;